import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {addColumn} from "scenes/Survey/Structure/data/columns/actions";
import LoadingSpinner from "components/LoadingSpinner";
import {Input} from "reactstrap";
import {isMobile, isTablet} from "react-device-detect";
import HtmlEditor
  from "../../../../../../../../../../../../../../../../../../../../../../../componentsReusable/HtmlEditor";
import getCKConfigByPlan from "utils/ckeditor/cafeteryConfig";
import {setPlanRestrictionsModals} from "reducers/planRestrictionsModals/actions";
import MultimediaAvailable from "components/PlanRestrictionsModals/modals/MultimediaAvailable";

class QuestionColumnNew extends Component {

  constructor(props) {
    super(props);

    this.state = {
      autoFocus: props.autoFocus,
      saving: false,
      adding: props.autoFocus,
      column: {
        content: '',
        position: props.position,
      }
    };

    this.onChangeContent = this.onChangeContent.bind(this);
    this.saveColumn = this.saveColumn.bind(this);
    this.closeIfEmpty = this.closeIfEmpty.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleKeyPress(e) {
    if (e.charCode === 13)
      this.saveColumn()
  }

  onChangeContent(content){
    if(this.state.saving){
      return;
    }

    this.setState({
      column: {
        ...this.state.column,
        content
      }
    })
  }

  saveColumn(){
    this.setState({adding: false});
    if(this.state.saving){
      return;
    }

    const column = {
      ...this.state.column,
      position: this.props.position
    };

    if ((column.content.trim()).length === 0)
      return false;

    this.setState({
      saving: true
    });
    
    this.props.addColumn({
      question: this.props.question.id,
      column
    }).then(() => {
      this.setState({
        saving: false,
        column: {
          ...this.state.column,
          content: ''
        }
      });

      this.props.handlerAdded && this.props.handlerAdded();
    });
  }

  closeIfEmpty() {
    if ((this.state.column.content.trim()).length === 0) {
      this.props.handlerAdded && this.props.handlerAdded();
    }
  }

  render() {
    const {column, saving, adding, autoFocus} = this.state;
    const {question, plan} = this.props;
    const ctrlEnterKeyCode = 1114125;
    let editor;

    if(question.columnsImage){
      return (
        <div className="line-wrap">
          <ul className="mb-0 ml-5">
            <li className="float-left">
              {saving ?
                <LoadingSpinner width={21} classNames={'my-0'}/>
                :
                <small
                  onClick={() => {
                    if (!plan.multimedia.access) {
                      this.props.setPlanRestrictionsModals(MultimediaAvailable.getName());
                      return;
                    }
                    CKFinder.popup({
                      chooseFiles: true,
                      width: 1014,
                      height: 700,
                      onInit: finder => {
                        finder.on('files:choose', e => {
                          this.onChangeContent(e.data.files.first().getUrl());
                          this.saveColumn();
                        });
                      }
                    })
                  }}
                ><FormattedMessage id="columns.columnNew.inputImage.placeholder" /></small>
              }
            </li>
          </ul>
        </div>
      )
    }

    if (isMobile || isTablet) {
      editor = <Input value={column.content} onChange={e => this.onChangeContent(e.target.value)} onBlur={this.saveColumn} autoFocus={autoFocus} onKeyPress={this.handleKeyPress}/>
    } else {
      editor = <HtmlEditor
        data={column.content}
        config={getCKConfigByPlan(plan)}
        type="inline"
        onChange={event => this.onChangeContent(event)}
        onBlur={event => {
          this.saveColumn();
          this.setState({editing: false})
        }}
        onKey={event => {
          if (event.data.keyCode === ctrlEnterKeyCode) {
            event.cancel();
            this.saveColumn();
            setTimeout(() => {
              event.editor.destroy();
              this.setState({editing: false})
            }, 1);
          }
        }}
      />
    }

    return (
      <div className="line-wrap d-print-none">
        <ul className="mb-0 ml-lg-5 d-flex">
          <li className="flex-grow-1">

            {adding
              ? editor
              : saving
                ? <LoadingSpinner width={21} classNames="my-0"/>
                : <small onClick={() => this.setState({adding: true, autoFocus: true})}><i><FormattedMessage id="columns.columnNew.input.placeholder" /></i></small>
            }

          </li>
        </ul>
      </div>
    )
  }
}

QuestionColumnNew.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    columnsImage: PropTypes.bool.isRequired,
  }).isRequired,
  position: PropTypes.number.isRequired,
  handlerAdded: PropTypes.func,
  autoFocus: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    plan: state.user.userPlan.plan
  }
}

export default connect(mapStateToProps, {addColumn, setPlanRestrictionsModals})(QuestionColumnNew);